export default "__VITE_ASSET__C$o14sZq__"